import React from 'react';
import { TrendingUp, Calculator, ShieldCheck, Star, Users, RefreshCw } from 'lucide-react';

export default function StatsBar() {
  const stats = [
    {
      icon: <TrendingUp className="w-5 h-5 text-[#16325B]" />,
      iconBg: "bg-[#EEF4FA]",
      value: "8+",
      label: "Years in Markets"
    },
    {
      icon: <Calculator className="w-5 h-5 text-[#2563EB]" />,
      iconBg: "bg-[#EFF6FF]",
      value: "12+",
      label: "Financial Solutions"
    },
    {
      icon: <ShieldCheck className="w-5 h-5 text-[#7C3AED]" />,
      iconBg: "bg-[#F3E8FF]",
      value: "3",
      label: "Certifications"
    },
    {
      icon: <Star className="w-5 h-5 text-[#D97706]" />,
      iconBg: "bg-[#FEF3C7]",
      value: "4.9/5",
      label: "Learner Rating"
    },
    {
      icon: <Users className="w-5 h-5 text-[#1E3A8A]" />,
      iconBg: "bg-[#DBEAFE]",
      value: "100%",
      label: "Educational Platform"
    },
    {
      icon: <RefreshCw className="w-5 h-5 text-[#EA580C]" />,
      iconBg: "bg-[#FFEDD5]",
      value: "0",
      label: "Sales Calls. Ever."
    }
  ];

  return (
    <section className="bg-white border-y border-gray-200/80 py-8 px-6 my-6 font-sans">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 divide-y lg:divide-y-0 lg:divide-x divide-gray-200/80 gap-y-6 lg:gap-y-0">
          {stats.map((item, index) => (
            <div 
              key={index} 
              className={`flex items-center gap-3.5 ${
                index !== 0 ? 'lg:pl-6' : ''
              } ${index % 2 !== 0 ? 'pl-4 lg:pl-6' : ''} pt-4 lg:pt-0`}
            >
              {/* Circular Icon Container */}
              <div className={`w-11 h-11 rounded-full flex items-center justify-center shrink-0 ${item.iconBg}`}>
                {item.icon}
              </div>

              {/* Number Value & Label */}
              <div className="flex flex-col">
                <span className="font-serif-title text-2xl font-bold text-[#0A2540] leading-none mb-1">
                  {item.value}
                </span>
                <span className="text-xs text-gray-500 font-medium leading-tight whitespace-nowrap">
                  {item.label}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}